import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";
import ReactQuill from "react-quill-new";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { createBlogApi, getBlogCategoriesApi, getBlogTagsApi } from "../../helper/api_helper";
import { Icon } from "@iconify/react/dist/iconify.js";
// import { toast } from "react-toastify";

import toast from "react-hot-toast";
const AddBlog = () => {
    const navigate = useNavigate()
    const [imagePreview, setImagePreview] = useState(null);

    // const handleFileChange = (e) => {
    //     if (e.target.files && e.target.files.length > 0) {
    //         const src = URL.createObjectURL(e.target.files[0]);
    //         setImagePreview(src);
    //     }
    // };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({
                ...prev,
                blog_image: file
            }));

            // Create preview
            const reader = new FileReader();
            reader.onload = (e) => {
                setImagePreview(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };
    const handleRemoveImage = () => {
        setFormData(prev => ({
            ...prev,
            blog_image: null
        }));
        setImagePreview(null);

        // Reset file input
        const fileInput = document.getElementById('upload-file');
        if (fileInput) {
            fileInput.value = '';
        }
    };
    const quillRef = useRef(null);
    const [value, setValue] = useState(``);
    // eslint-disable-next-line no-unused-vars
    const [isHighlightReady, setIsHighlightReady] = useState(false);
    const [formData, setFormData] = useState({
        blog_title: '',
        blog_category_id: '',
        blog_tag_ids: [], // Changed to array for multiple tags
        blog_description: '',
        blog_image: null
    });

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);

    // eslint-disable-next-line no-unused-vars
    const handleSave = () => {
        const editorContent = quillRef.current.getEditor().root.innerHTML;
    };

    // Quill editor modules with syntax highlighting (only load if highlight.js is ready)
    const modules = isHighlightReady
        ? {
            syntax: {
                highlight: (text) => hljs?.highlightAuto(text).value, // Enable highlight.js in Quill
            },
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        }
        : {
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        };

    const formats = [
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "script",
        "header",
        "blockquote",
        "code-block",
        "list",
        "indent",
        "direction",
        "align",
        "link",
        "image",
        "video",
        "formula",
    ];

    const [isCategoriesLoading, setIsCategoriesLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [blogTags, setBlogTags] = useState([]);


    const [creatingBlog, setCreatingBlog] = useState(false);



    const [isTagsLoading, setIsTagsLoading] = useState(false);





    const getAllBlogCategories = async () => {
        try {
            setIsCategoriesLoading(true);
            const response = await getBlogCategoriesApi();

            setCategories(response.data);

        } catch (error) {
            toast.error("Failed to fetch categories");
            setCategories([]);
        } finally {
            setIsCategoriesLoading(false);
        }
    };

    useEffect(() => {
        getAllBlogCategories();
    }, []);




    const getAllBlogTags = async () => {
        try {
            setIsTagsLoading(true);
            const response = await getBlogTagsApi();

            setBlogTags(response.data);

        } catch (error) {

            toast.error("Failed to fetch tags");
            setBlogTags([]);
        } finally {
            setIsTagsLoading(false);
        }
    };

    useEffect(() => {
        getAllBlogCategories();
        getAllBlogTags();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handle description change (Quill editor)
    const handleDescriptionChange = (content) => {
        setFormData(prev => ({
            ...prev,
            blog_description: content
        }));
    };

    const handleTagChange = (e) => {
        const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
        setFormData(prev => ({
            ...prev,
            blog_tag_ids: selectedOptions
        }));
    };

    const createBlog = async () => {
        try {
            setCreatingBlog(true);

            // Create FormData object
            const formDataToSend = new FormData();
            formDataToSend.append('blog_title', formData.blog_title);
            formDataToSend.append('blog_category_id', formData.blog_category_id);

            // Append multiple tag IDs - try different formats based on your backend
            // Option 1: As separate entries with same key (most common)
            formData.blog_tag_ids.forEach((tagId) => {
                formDataToSend.append('blog_tag_id', tagId);
            });

            // Option 2: As JSON string (uncomment if backend expects JSON)
            // formDataToSend.append('blog_tag_ids', JSON.stringify(formData.blog_tag_ids));

            // Option 3: As indexed array (uncomment if backend expects indexed format)
            // formData.blog_tag_ids.forEach((tagId, index) => {
            //     formDataToSend.append(`blog_tag_id[${index}]`, tagId);
            // });

            formDataToSend.append('blog_description', formData.blog_description);

            if (formData.blog_image) {
                formDataToSend.append('blog_image', formData.blog_image);
            }

            for (let [key, value] of formDataToSend.entries()) {
                
            }

            const response = await createBlogApi(formDataToSend);

            // More flexible response checking
            // if (response && (response.success || response.status === 'success' || response.data)) {
            toast.success(response.message || "Blog created successfully!");
            navigate("/blog")
            // Reset form
            setFormData({
                blog_title: '',
                blog_category_id: '',
                blog_tag_ids: [],
                blog_description: '',
                blog_image: null
            });
            setImagePreview(null);

            // Reset file input
            const fileInput = document.getElementById('upload-file');
            if (fileInput) {
                fileInput.value = '';
            }

            // Optionally redirect or update state
            // Navigate('/blogs'); // Uncomment if using react-router
            // } else {
            //     toast.error(response?.message || "Failed to create blog");
            // }

        } catch (error) {
            
            // const errorMessage = error?.response?.data?.message ||
            //     error?.message ||
            //     "Failed to create blog. Please check your network connection.";
            // toast.error(errorMessage);

            if (error?.code === "ERR_NETWORK") {

                toast.error("Image size is too large. Please upload a smaller file.");
            } else {
                toast.error(error || "Something went wrong");
            }


        } finally {
            setCreatingBlog(false);
        }
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        // Basic validation
        if (!formData.blog_title.trim()) {
            toast.error("Please enter blog title");
            return;
        }

        if (!formData.blog_category_id) {
            toast.error("Please select a category");
            return;
        }

        if (formData.blog_tag_ids.length === 0) {
            toast.error("Please select at least one tag");
            return;
        }

        if (!formData.blog_description.trim()) {
            toast.error("Please enter blog description");
            return;
        }
        if (!formData.blog_image) {
            toast.error("Please upload a blog image");
            return;
        }
        createBlog();
    };

    const handleTagToggle = (tagId) => {
        setFormData(prev => ({
            ...prev,
            blog_tag_ids: prev.blog_tag_ids.includes(tagId)
                ? prev.blog_tag_ids.filter(id => id !== tagId)
                : [...prev.blog_tag_ids, tagId]
        }));
    };

    const removeTag = (tagId) => {
        setFormData(prev => ({
            ...prev,
            blog_tag_ids: prev.blog_tag_ids.filter(id => id !== tagId)
        }));
    };

    return (
        <div className='row gy-4'>
            <div className='col-lg-12'>
                <div className='card mt-24'>
                    <div className='card-header border-bottom'>
                        <h6 className='text-xl mb-0'>Add New Blog</h6>
                    </div>
                    <div className='card-body p-24'>
                        <form onSubmit={handleSubmit} className='d-flex flex-column gap-20'>
                            {/* Blog Title */}
                            <div>
                                <label
                                    className='form-label fw-bold text-neutral-900'
                                    htmlFor='title'
                                >
                                    Blog Title:
                                </label>
                                <input
                                    type='text'
                                    name='blog_title'
                                    className='form-control border border-neutral-200 radius-8'
                                    id='title'
                                    placeholder='Enter Post Title'
                                    value={formData.blog_title}
                                    onChange={handleInputChange}
                                />
                            </div>

                            {/* Blog Category */}
                            <div>
                                <label className='form-label fw-bold text-neutral-900'>
                                    Blog Category:
                                </label>
                                <select
                                    name='blog_category_id'
                                    className='form-control border border-neutral-200 radius-8'
                                    value={formData.blog_category_id}
                                    onChange={handleInputChange}
                                >
                                    <option value=''>Select Category</option>
                                    {categories.map((category) => (
                                        <option key={category.id} value={category.id}>
                                            {category.category_name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Blog Tags */}
                            {/* <div>
                                <label className='form-label fw-bold text-neutral-900'>
                                    Blog Tags:
                                </label>
                                <select
                                    name='blog_tag_id'
                                    className='form-control border border-neutral-200 radius-8'
                                    value={formData.blog_tag_id}
                                    onChange={handleInputChange}
                                >
                                    <option value=''>Select Tag</option>
                                    {blogTags.map((tag) => (
                                        <option key={tag.id} value={tag.id}>
                                            {tag.tag_name}
                                        </option>
                                    ))}
                                </select>
                            </div> */}

                            <div>
                                <label className='form-label fw-bold text-neutral-900'>
                                    Blog Tags:
                                </label>

                                {/* Selected Tags Display */}
                                {formData.blog_tag_ids.length > 0 && (
                                    <div className='mb-3'>
                                        <div className='d-flex flex-wrap gap-2'>
                                            {formData.blog_tag_ids.map(tagId => {
                                                const tag = blogTags.find(t => t.id === tagId);
                                                return (
                                                    <span
                                                        key={tagId}
                                                        className='badge bg-primary-100 text-primary-600 px-3 py-2 rounded-pill d-flex align-items-center gap-1'
                                                        style={{ fontSize: '14px' }}
                                                    >
                                                        {tag?.tag_name}
                                                        <button
                                                            type='button'
                                                            className='btn-close btn-close-sm ms-1'
                                                            style={{ fontSize: '10px', width: '12px', height: '12px' }}
                                                            onClick={() => removeTag(tagId)}
                                                            aria-label='Remove tag'
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                                {/* Tags Selection */}
                                <div className='border border-neutral-200 radius-8 p-3' style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                    {blogTags.length > 0 ? (
                                        <div className='row g-2'>
                                            {blogTags.map((tag) => (
                                                <div key={tag.id} className='col-md-6 col-lg-4'>
                                                    <div className='form-check' style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                        <input
                                                            className='form-check-input'
                                                            type='checkbox'
                                                            id={`tag-${tag.id}`}
                                                            checked={formData.blog_tag_ids.includes(tag.id)}
                                                            onChange={() => handleTagToggle(tag.id)}
                                                        />
                                                        <label
                                                            className='form-check-label text-sm'
                                                            htmlFor={`tag-${tag.id}`}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            {tag.tag_name}
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <p className='text-muted text-center mb-0'>No tags available</p>
                                    )}
                                </div>

                                {/* Selection Counter */}
                                <small className='text-muted mt-1 d-block'>
                                    {formData.blog_tag_ids.length} tag{formData.blog_tag_ids.length !== 1 ? 's' : ''} selected
                                </small>
                            </div>


                            {/* Blog Description */}
                            <div>
                                <label className='form-label fw-bold text-neutral-900'>
                                    Blog Description
                                </label>
                                <div className='border border-neutral-200 radius-8 overflow-hidden'>
                                    <div className='height-200'>
                                        <div id='toolbar-container'>
                                            <span className='ql-formats'>
                                                <select className='ql-font'></select>
                                                <select className='ql-size'></select>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-bold'></button>
                                                <button className='ql-italic'></button>
                                                <button className='ql-underline'></button>
                                                <button className='ql-strike'></button>
                                            </span>
                                            <span className='ql-formats'>
                                                <select className='ql-color'></select>
                                                <select className='ql-background'></select>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-script' value='sub'></button>
                                                <button className='ql-script' value='super'></button>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-header' value='1'></button>
                                                <button className='ql-header' value='2'></button>
                                                <button className='ql-blockquote'></button>
                                                <button className='ql-code-block'></button>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-list' value='ordered'></button>
                                                <button className='ql-list' value='bullet'></button>
                                                <button className='ql-indent' value='-1'></button>
                                                <button className='ql-indent' value='+1'></button>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-direction' value='rtl'></button>
                                                <select className='ql-align'></select>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-link'></button>
                                                <button className='ql-image'></button>
                                                <button className='ql-video'></button>
                                                <button className='ql-formula'></button>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-clean'></button>
                                            </span>
                                        </div>

                                        <ReactQuill
                                            ref={quillRef}
                                            theme='snow'
                                            value={formData.blog_description}
                                            onChange={handleDescriptionChange}
                                            modules={modules}
                                            formats={formats}
                                            placeholder='Compose an epic...'
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Blog Image */}
                            <div>
                                <label className='form-label fw-bold text-neutral-900'>
                                    Blog Image
                                </label>
                                <div className='upload-image-wrapper'>
                                    {imagePreview ? (
                                        <div className='uploaded-img position-relative h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50'>
                                            <button
                                                type='button'
                                                className='uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex bg-danger-600 w-40-px h-40-px justify-content-center align-items-center rounded-circle'
                                                onClick={handleRemoveImage}
                                            >
                                                <Icon
                                                    icon='radix-icons:cross-2'
                                                    className='text-2xl text-white'
                                                />
                                            </button>
                                            <img
                                                id='uploaded-img__preview'
                                                className='w-100 h-100 object-fit-cover'
                                                src={imagePreview}
                                                alt='Uploaded'
                                            />
                                        </div>
                                    ) : (
                                        <label
                                            className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1'
                                            htmlFor='upload-file'
                                        >
                                            <iconify-icon
                                                icon='solar:camera-outline'
                                                className='text-xl text-secondary-light'
                                            ></iconify-icon>
                                            <span className='fw-semibold text-secondary-light'>
                                                Upload
                                            </span>
                                            <input
                                                id='upload-file'
                                                type='file'
                                                accept='image/*'
                                                hidden
                                                onChange={handleFileChange}
                                            />
                                        </label>
                                    )}
                                </div>
                            </div>

                            {/* Submit Button */}
                            <button
                                type='submit'
                                className='btn btn-primary-600 radius-8'
                                disabled={creatingBlog}
                            >
                                {creatingBlog ? 'Creating...' : 'Submit'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            {/* Sidebar Start */}

        </div>
    );
};

export default AddBlog;
